// Shared browser history + a standalone `navigate` helper.
//
// react-router v6 removed @reach/router's standalone `navigate(path)` function
// (navigation is normally done via the useNavigate() hook, which only works
// inside components). Several call sites here navigate from non-component code
// (async callbacks, the auto-logout timer, etc.), so we keep a standalone
// `navigate` backed by a single history instance that is also handed to
// react-router's <HistoryRouter> in App.js. This preserves the existing
// `navigate("/path")` API across the app with only an import-path change.
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

// Mirrors @reach/router's navigate(to, { replace, state }) signature.
export function navigate(to, options = {}) {
  if (options && options.replace) {
    history.replace(to, options.state);
  } else {
    history.push(to, options.state);
  }
}

export default navigate;
